export default "__VITE_ASSET__CEwdCXHy__"